import React, { useLayoutEffect } from 'react';

export const useAutosizeTextarea = (
  textareaRef: React.RefObject<HTMLTextAreaElement | null>,
  value: string,
) => {
  useLayoutEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);
};
